module.exports = __webpack_public_path__ + "static/media/expert_advice.6ade7e51.svg";